import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { OutrightBetState } from './OutrightBet.state';


interface PropsTypes {
    outrightBetState: OutrightBetState
}

export const CompetitionFilter = observer('CompetitionFilter', ({ outrightBetState }: PropsTypes) => {
    return (
        <nav className='filters outright__competitions-filter'>
            <ul>
                {outrightBetState.competitionFilter.map(comp => {
                    const isActive = outrightBetState.activeCompetitionId === comp.id;

                    return (
                        <li key={comp.id} className={isActive ? 'filters outright__competitions-filter active' : 'filters outright__competitions-filter'}>
                            <a href='#' onClick={(): void => outrightBetState.onOpenCompetition(comp.id)}>
                                {comp.name}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
});
